<template>
  <div class="product-section">
    <div class="df vertical df-around">
      <div class="title">{{ query.localDate }} 异常问题统计和处理</div>
      <a-space>
        <!-- <select-day
          :defaultVal="query.localDate"
          @userDelectDay="userSelectDay"
        ></select-day> -->
        <a-button @click="handleUpdateAbnormalProblem(null)">新增</a-button>
      </a-space>
    </div>
    <form-vue
      ref="fqcRef"
      @updateTable="updateTable"
      :type="props.type"
      :produceOrTpc="props.produceOrTpc"
    ></form-vue>
    <div ref="tableScrollRef">
      <div class="df both-side" style="margin-top: 20px">
        <div style="margin: 0 auto; width: calc(100vw - 160px)">
          <a-table
            :columns="productColumns"
            :loading="tableLoading"
            :data-source="tableData"
            :pagination="false"
            :rowClassName="
              (record, index) => (index % 1 === 0 ? 'table-striped' : null)
            "
            rowKey="id"
            bordered
            :scroll="{ x: 'calc(100vw - 160px)' }"
          >
            <template #action="{ record }">
              <a-space>
                <a-button @click="handleEdit(record)" size="small"
                  >编辑</a-button
                >

                <a-button
                  v-if="props.deleteAuthority"
                  @click="handleDelete(record)"
                  type="danger"
                  size="small"
                  >删除</a-button
                >
              </a-space>
            </template>

            <template #picture="{ record }">
              <a-image
                v-for="img in JSON.parse(record.picture)"
                :key="img"
                :width="50"
                :src="img"
              />
            </template>

            <template #video="{ record }">
              <video
                v-for="video in JSON.parse(record.video)"
                :src="video"
                controls
                width="120"
                :key="video"
              ></video>
            </template>

            <template #notes="{ record }">
              <div v-if="record.notes">
                <template
                  v-for="(item, index) in JSON.parse(record.notes)"
                  :key="index"
                >
                  <a-image
                    v-for="img in JSON.parse(item.picture)"
                    :key="img"
                    :width="50"
                    :src="img"
                  />

                  <video
                    v-for="video in JSON.parse(item.video)"
                    :src="video"
                    controls
                    width="120"
                    :key="video"
                  ></video>

                  <div>
                    {{ item.desc }}
                  </div>
                </template>
              </div>
            </template>
          </a-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useStore } from "vuex";
import { computed, defineComponent, reactive, ref, inject, watch } from "vue";
import {
  getAbnormalProblemHandleList,
  deleteAbnormalProblemHandle,
} from "@/request/view/product";
import searchVue from "@/views/productDaily/components/quality/PQC/threePieced/search.vue";
import formVue from "@/views/productDaily/components/product/components/abnormalProblem/form.vue";
import SelectDay from "@/views/repairprogress/compoments/selectDay.vue";
import { showModal } from "@/views/repairprogress/serve/modal";
import { Toast, debounce, timeStampToTime } from "@/utils";

export default defineComponent({
  props: {
    type: String,
    deleteAuthority: Boolean,
    produceOrTpc: String,
  },
  components: {
    searchVue,
    formVue,
    SelectDay,
  },
  setup(props, context) {
    const query = reactive({
      localDate: timeStampToTime("", "upload"),
      type: props.type,
      produceOrTpc: props.produceOrTpc
    });
    const store = useStore();

    const userId = computed(() => store.state.user.user.id);

    const productColumns = [
      {
        title: "序号",
        dataIndex: "id",
        width: 80,
        align: "center",
      },
      {
        title: "问题",
        dataIndex: "problem",
        width: 165,
        align: "center",
      },
      {
        title: "图片",
        dataIndex: "picture",
        width: 165,
        align: "center",
        slots: { customRender: "picture" },
      },
      {
        title: "视频",
        dataIndex: "video",
        width: 165,
        align: "center",
        slots: { customRender: "video" },
      },
      {
        title: "部件名称",
        dataIndex: "componentName",
        width: 165,
        align: "center",
      },
      {
        title: "部件编码",
        dataIndex: "componentCode",
        width: 165,
        align: "center",
      },
      {
        title: "原因",
        dataIndex: "reason",
        width: 165,
        align: "center",
      },
      {
        title: "处理措施",
        dataIndex: "handlingMeasures",
        width: 165,
        align: "center",
      },
      {
        title: "处理类型",
        dataIndex: "processType",
        width: 100,
        align: "center",
      },
      {
        title: "状态",
        dataIndex: "status",
        width: 100,
        align: "center",
      },
      {
        title: "备注",
        dataIndex: "notes",
        width: 165,
        align: "center",
        slots: {
          customRender: "notes",
        },
      },
      {
        title: "操作",
        slots: {
          customRender: "action",
        },
        width: 120,
        align: "center",
        fixed: "right",
      },
    ];

    const tableLoading = ref(false);

    const searchRef = ref();

    const fqcRef = ref();

    const tableScrollRef = ref();

    const tableData = reactive([]);

    const getTableData = () => {
      tableLoading.value = true;
      getAbnormalProblemHandleList(query)
        .then((res) => {
          tableLoading.value = false;
          tableData.length = 0;
          if (
            res.code === 200 &&
            res.message === "成功" &&
            res.data &&
            res.data[props.type]
          ) {
            tableData.push(...res.data[props.type]);
          }
        })
        .catch((err) => {
          tableLoading.value = false;
          console.log(err, "报错");
        });
    };

    const handleDelete = (record) => {
      showModal({
        title: "提示",
        toastText: "确认删除？",
        success: () => {
          deleteAbnormalProblemHandle([record.id])
            .then((res) => {
              Toast(res.code === 200 ? "success" : "warning", res.message, 3);
              if (res.code === 200) {
                getTableData();
              }
            })
            .catch((err) => {
              console.log(err);
            });
        },
      });
    };

    const userSelectDay = (time) => {
      if (time) {
        query.localDate = time;
        getTableData();
      }
    };

    const handleEdit = (data) => {
      fqcRef.value.openModal("editProblem", data);
    };

    const handleUpdateAbnormalProblem = () => {
      fqcRef.value.openModal("addProblem");
    };

    const updateTable = () => {
      getTableData();
    };

    const tabActivekey = inject("tabActivekey", null);

    watch(
      () => tabActivekey,
      (val) => {
        if (val.value === props.type) {
          getTableData();
        }
      },
      {
        immediate: true,
        deep: true,
      }
    );

    const cascadeDate = inject("cascadeDate", null);
    watch(
      () => cascadeDate,
      (val) => {
        if (!val.value) return;
        const date = val.value.format("YYYY-MM-DD");
        if (date !== query.localDate) {
          query.localDate = date;
          getTableData();
        }
      },
      {
        immediate: true,
        deep: true,
      }
    );

    return {
      props,
      query,
      userId,
      handleDelete,
      productColumns,
      searchRef,
      fqcRef,
      tableData,
      tableLoading,
      userSelectDay,
      tableScrollRef,
      handleUpdateAbnormalProblem,
      updateTable,
      handleEdit,
    };
  },
});
</script>

<style lang="less" scoped>
</style>
